import { BaseEntity } from "yt-ng-framework";

export class VoziloView extends BaseEntity{
    constructor(){
        super();
    }
    Naziv: string;
    VrstaVozila: string;
    RgBr: string;
    DatumReg: Date = null;
    BrSbDozv: string;
    Marka: string;
    Model: string;
    Masa: number;
    Nosivost: number;
    BrojOsovina: number;
    GodinaProizvodnje: number;
    Boja: string;
    BrojSasije: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.VrstaVozila = input.VrstaVozila;
        this.RgBr = input.RgBr;
        this.DatumReg = input.DatumReg;
        this.BrSbDozv = input.BrSbDozv;
        this.Marka = input.Marka;
        this.Model = input.Model;
        this.Masa = input.Masa;
        this.Nosivost = input.Nosivost;
        this.BrojOsovina = input.BrojOsovina;
        this.GodinaProizvodnje = input.GodinaProizvodnje;
        this.Boja = input.Boja;
        this.BrojSasije = input.BrojSasije;
       
        return this;
    }

    Serialize(input: VoziloView){
        return input;
    }
}